/* eslint new-cap: 0 */
/* global PSSessions, analyticsIntegrations */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { LocationModal } from './location-modal';
import clickOutside from 'react-click-outside';

class ErrorDropdown extends React.Component {
  constructor (props) {
    super(props);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside (e) {
    const ignoreClickOutside = $(e.target).hasClass('ignore-clickoutside');
    if (this.props.enableClickOutside && !ignoreClickOutside) {
      this.props.closeDropdown();
    }
  }

  render () {
    return (
      <div role="menu" aria-expanded="false" className="dropdown-menu">
        <div className="container-fluid error-dropdown">
          <div className="row border-bottom">
            <div className="row-height">
              <div className="col-xs-12 col-height col-middle">
                { this.props.content }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ErrorDropdown.propTypes = {
  enableClickOutside: PropTypes.bool,
  closeDropdown: PropTypes.func
};

exports.ErrorDropdown = clickOutside(ErrorDropdown);
